import { DialogContentClassKey } from "@material-ui/core";
import { StyleRules } from "@material-ui/core/styles";

export const MuiDialogContent: Partial<StyleRules<DialogContentClassKey>> = {
  dividers: {
    padding: "16px 24px",
    borderBottom: "none",
  },
};
